import FaIcon from '../utils/FaIcon';

const Testimonials = () => (
    <div className='cards-wrapper flex-wrap'>
        <div className='card center-card'>
            <h3 style={{ color: "#e47931" }}>What Our Clients Say</h3>
            <h1>Testimonials</h1>
            <p>We take pride in our partnerships with some of the most respected names in the industry. Our commitment to quality and excellence has earned us the trust of these esteemed clients.</p>
        </div>
        <div className='card testimonial-card'>
            <FaIcon icon="fa-solid fa-quote-left" color="#e47931" />
            <p>Glometal's commitment to quality and excellence is unmatched. Their team is always ready to go the extra mile to ensure our projects are a success.</p>
            <div className="right-text">
                <FaIcon icon="fa-solid fa-quote-right" color="#e47931" />
                <h4>Prashant Madi</h4>
                <h5>Coldaire</h5>
            </div>
        </div>
        <div className='card testimonial-card'>
            <FaIcon icon="fa-solid fa-quote-left" color="#e47931" />
            <p>Working with Glometal has been a game-changer for our projects. Their expertise and dedication to quality are truly commendable.</p>
            <div className="right-text">
                <FaIcon icon="fa-solid fa-quote-right" color="#e47931" />
                <h4>Vamshi</h4>
                <h5>Sumadhura (logistic park)</h5>
            </div>
        </div>
        <div className='card testimonial-card'>
            <FaIcon icon="fa-solid fa-quote-left" color="#e47931" />
            <p>Glometal's attention to detail and commitment to customer satisfaction is what sets them apart. We are proud to partner with them.</p>
            <div className="right-text">
                <FaIcon icon="fa-solid fa-quote-right" color="#e47931" />
                <h4>V V Reddy</h4>
                <h5>V V Electricals</h5>
            </div>
        </div>

    </div>
);

export default Testimonials;